import axios from 'axios'; // 引入axios
import qs from 'qs';
import router from '@/router'

export function post(url, params) {
    return new Promise((resolve, reject) => {
         axios.post(url,qs.stringify(params))
        .then(res => {
    
            resolve(res);
            
        })
        .catch(err =>{
            reject(err)
        })
    });
}


// WEBPACK FOOTER //
// ./src/https/api.js